/**
 * tdesign v1.8.0
 * (c) 2024 tdesign
 * @license MIT
 */

import { computed } from 'vue';
import useVirtualScroll from '../../hooks/useVirtualScrollNew.mjs';
import '../../_chunks/dep-f7837681.mjs';
import '../../_chunks/dep-6bcce672.mjs';
import '../../_chunks/dep-89b33ff6.mjs';
import '../../hooks/useResizeObserver.mjs';

var useListVirtualScroll = function useListVirtualScroll(scroll, listRef, listItems) {
  var virtualScrollParams = computed(function () {
    return {
      data: listItems.value,
      scroll: scroll
    };
  });
  var virtualConfig = useVirtualScroll(listRef, virtualScrollParams);
  var isVirtualScroll = computed(function () {
    return virtualConfig.isVirtualScroll.value;
  });
  var lastScrollY = -1;
  var onInnerVirtualScroll = function onInnerVirtualScroll(e) {
    var target = e.target || e.srcElement;
    var top = target.scrollTop;
    if (lastScrollY !== top) {
      virtualConfig.isVirtualScroll.value && virtualConfig.handleScroll();
    } else {
      lastScrollY = -1;
    }
    lastScrollY = top;
  };
  var cursorStyle = computed(function () {
    return {
      position: "absolute",
      width: "1px",
      height: "1px",
      transition: "transform 0.2s",
      transform: "translate(0, ".concat(virtualConfig.scrollHeight.value, "px)"),
      "-ms-transform": "translate(0, ".concat(virtualConfig.scrollHeight.value, "px)"),
      "-moz-transform": "translate(0, ".concat(virtualConfig.scrollHeight.value, "px)"),
      "-webkit-transform": "translate(0, ".concat(virtualConfig.scrollHeight.value, "px)")
    };
  });
  var listStyle = computed(function () {
    return {
      transform: "translate(0, ".concat(virtualConfig.translateY.value, "px)"),
      "-ms-transform": "translate(0, ".concat(virtualConfig.translateY.value, "px)"),
      "-moz-transform": "translate(0, ".concat(virtualConfig.translateY.value, "px)"),
      "-webkit-transform": "translate(0, ".concat(virtualConfig.translateY.value, "px)")
    };
  });
  return {
    virtualConfig: virtualConfig,
    cursorStyle: cursorStyle,
    listStyle: listStyle,
    isVirtualScroll: isVirtualScroll,
    onInnerVirtualScroll: onInnerVirtualScroll
  };
};

export { useListVirtualScroll };
//# sourceMappingURL=useListVirtualScroll.mjs.map
